// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.custom-invalid {
  border: 1px solid red !important;
}

.validation-text {
  display: block;
  margin-top: 5px;
  color: red;
}

.max-img-note {
  font-size: 12px;
  margin: 8px 0 20px 0;
}

.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 300px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header .table-calendar-wrapper,
.table-header .field,
.table-header p-button {
  margin: 0;
}
.table-header .field {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.gc-report-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

:host ::ng-deep .p-button.p-button-icon-only:disabled {
  color: #9CA3AF;
}`, "",{"version":3,"sources":["webpack://./src/app/reports/reports.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,eAAA;EACA,YAAA;AACJ;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,6BAAA;AAGF;;AADA;EACE,gCAAA;AAIF;;AAFA;EACE,cAAA;EACA,eAAA;EACA,UAAA;AAKF;;AAHA;EACE,eAAA;EACA,oBAAA;AAMF;;AAFE;EACE,cAAA;AAKJ;AAFE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAIJ;AADE;;;EAGE,SAAA;AAGJ;AAAE;EACE,2BAAA;AAEJ;AACE;EArBF;IAsBI,eAAA;IACA,2BAAA;EAEF;EADE;IACE,eAAA;IACA,WAAA;EAGJ;AACF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".disabled {\n    pointer-events: none;\n    cursor: default;\n    opacity: 0.6;\n  }\n\n.icon-badge-gold:before {\n  content: \"\\e900\";\n  color: #f2c94c;\n}\n.gc-pr-12{\n  padding-right: 12px !important;\n}\n.gc-pl-12{\n  padding-left: 12px !important;\n}\n.custom-invalid {\n  border: 1px solid red !important;\n}\n.validation-text{\n  display: block;\n  margin-top: 5px;\n  color: red;\n}\n.max-img-note {\n  font-size: 12px;\n  margin: 8px 0 20px 0;\n}\n\n.table-header{\n  h2 {\n    line-height: 1;\n  }\n\n  .table-search-wrapper {\n    max-width: 300px;\n    flex: 1 1 auto;\n    margin: 0;\n  }\n\n  .table-calendar-wrapper,\n  .field,\n  p-button {\n    margin: 0;\n  }\n\n  .field {\n    margin-bottom: 0 !important;\n  }\n\n  @media(max-width:1200px) {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .table-search-wrapper{\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.gc-report-name{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #1F2937;\n}\n\n// Grey-out/Disable only icon buttons\n:host ::ng-deep .p-button.p-button-icon-only:disabled {\n  color: #9CA3AF;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
